import { render, staticRenderFns } from "./lottery-result.vue?vue&type=template&id=7649da05&scoped=true&"
import script from "./lottery-result.vue?vue&type=script&lang=js&"
export * from "./lottery-result.vue?vue&type=script&lang=js&"
import style0 from "./lottery-result.vue?vue&type=style&index=0&id=7649da05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7649da05",
  null
  
)

export default component.exports